import React from 'react';
import { Home, Target, UtensilsCrossed, Dumbbell } from 'lucide-react';

const GolfEquipements = () => {
  // Facilities from the project documents
  const equipements = [
    {
      icon: Home,
      title: 'Club House',
      subtitle: 'Bar, Starter, Caddy Master',
      description: 'Architecture contemporaine avec matériaux naturels'
    },
    {
      icon: Target,
      title: 'Practice',
      subtitle: 'Double side 300m',
      description: 'Aire d\'entraînement professionnelle'
    },
    {
      icon: UtensilsCrossed,
      title: 'Restaurant',
      subtitle: 'Gastronomie & terrasse',
      description: 'Vue panoramique sur le parcours'
    },
    {
      icon: Dumbbell,
      title: 'Zone Chipping',
      subtitle: 'Entraînement approche',
      description: 'Perfectionnement du petit jeu'
    }
  ];

  return (
    <section id="equipements" className="py-32 lg:py-40 bg-white relative">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-24">
          <span className="font-montserrat text-[#c9a962] text-xs tracking-[0.4em] uppercase">
            Infrastructures
          </span>
          <div className="w-16 h-px bg-[#c9a962] mx-auto my-8" />
          <h2 className="font-playfair text-4xl lg:text-5xl text-[#1a3c2a]">
            L'excellence des <span className="text-[#c9a962] italic">équipements</span>
          </h2>
          <p className="font-montserrat text-gray-500 mt-6 max-w-2xl mx-auto">
            Des installations haut de gamme conçues pour offrir une expérience 
            golfique complète et un confort optimal.
          </p>
        </div>

        {/* Equipements Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {equipements.map((item, index) => (
            <div key={index} className="text-center group">
              {/* Icon */}
              <div className="w-16 h-16 mx-auto mb-6 rounded-full border border-[#c9a962]/30 flex items-center justify-center group-hover:border-[#c9a962] group-hover:bg-[#c9a962]/5 transition-all duration-500">
                <item.icon className="w-6 h-6 text-[#c9a962] stroke-[1.5]" />
              </div>
              
              {/* Title */}
              <h3 className="font-playfair text-xl text-[#1a3c2a] mb-2">
                {item.title}
              </h3>
              
              {/* Subtitle */}
              <p className="font-montserrat text-[#c9a962] text-xs tracking-wider uppercase mb-2">
                {item.subtitle}
              </p>
              
              {/* Description */}
              <p className="font-montserrat text-sm text-gray-400 font-light">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Technical Specs Section */}
        <div className="mt-24 bg-[#faf8f5] p-8 lg:p-12 rounded-sm">
          <div className="text-center mb-10">
            <h3 className="font-playfair text-2xl text-[#1a3c2a]">
              Spécifications <span className="text-[#c9a962] italic">techniques</span>
            </h3>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="font-playfair text-3xl text-[#c9a962] mb-2">USGA</div>
              <div className="font-montserrat text-sm text-[#1a3c2a] font-medium">Greens aux normes</div>
              <p className="font-montserrat text-xs text-gray-500 mt-2">
                Construction selon recommandations USGA avec substrat sableux et drainage optimisé
              </p>
            </div>
            <div className="text-center">
              <div className="font-playfair text-3xl text-[#c9a962] mb-2">150-300</div>
              <div className="font-montserrat text-sm text-[#1a3c2a] font-medium">mm/h conductivité</div>
              <p className="font-montserrat text-xs text-gray-500 mt-2">
                Conductivité hydraulique saturée pour une évacuation rapide de l'eau
              </p>
            </div>
            <div className="text-center">
              <div className="font-playfair text-3xl text-[#c9a962] mb-2">35-55%</div>
              <div className="font-montserrat text-sm text-[#1a3c2a] font-medium">Porosité totale</div>
              <p className="font-montserrat text-xs text-gray-500 mt-2">
                Équilibre air/eau optimal pour la santé du gazon et la jouabilité
              </p>
            </div>
          </div>
        </div>

        {/* Decorative Element */}
        <div className="flex items-center justify-center gap-4 mt-24">
          <div className="w-16 h-px bg-gray-200" />
          <div className="w-2 h-2 bg-[#c9a962] rotate-45" />
          <div className="w-16 h-px bg-gray-200" />
        </div>
      </div>
    </section>
  );
};

export default GolfEquipements;
